// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationMenu__container___LJ1Pw {
	position: fixed;
	top: 50%;
	left: -4px;
	transform: translateY(-50%);
	padding: 4px;
	border-radius: 0 18px 18px 0;
	background: rgba(0, 0, 0, 0.18);
	backdrop-filter: blur(5px);
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
	font-size: 16px;
	color: rgba(167, 190, 188, 0.76);
	z-index: 10;
	opacity: 0.62;
	transition: opacity 180ms ease;
}

.NavigationMenu__container___LJ1Pw:hover,
.NavigationMenu__container___LJ1Pw:focus-within {
	opacity: 0.86;
}

.NavigationMenu__items___X0Fwz {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.NavigationMenu__badge_green___XMbTb {
	background-color: green !important;
}

.NavigationMenu__badge_yellow___fd89u {
	background-color: #8a5c18 !important;
}

.NavigationMenu__badge_red___rocBN {
	background-color: red !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavigationMenu__container___LJ1Pw`,
	"items": `NavigationMenu__items___X0Fwz`,
	"badge_green": `NavigationMenu__badge_green___XMbTb`,
	"badge_yellow": `NavigationMenu__badge_yellow___fd89u`,
	"badge_red": `NavigationMenu__badge_red___rocBN`
};
module.exports = ___CSS_LOADER_EXPORT___;
